export function useMedia(screen: number) {
  const isMobile = ref(true);

  onMounted(() => {
    const media = window.matchMedia(`(max-width: ${screen}px)`);

    const updateIsMobile = () => {
      isMobile.value = media.matches;
    };

    media.addEventListener("change", updateIsMobile);

    updateIsMobile();

    return () => {
      media.removeEventListener("change", updateIsMobile);
    };
  });

  return isMobile;
}
